import React, { Component } from 'react';
import PropTypes from 'prop-types';

import {
  includesSearchText,
  toStartCase,
} from 'helpers/utils';
import {
  get,
} from 'lodash';

import {
  Divider,
  HighlightText,
} from 'components';

class OrderSheetBoxItem extends Component {
  static propTypes = {
    data: PropTypes.shape({}).isRequired,
    fields: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
    isOrderedTable: PropTypes.bool,
    searchText: PropTypes.string,
    isAllowedZero: PropTypes.bool,
  };

  static defaultProps = {
    isOrderedTable: false,
    searchText: '',
    isAllowedZero: false,
  };

  getGroups = () => {
    const { data, searchText, isAllowedZero } = this.props;
    const modifiedData = [];
    if (!data) return [];
    if (data) {
      let packRowCount = 0;
      data.packrows.forEach((packrow) => {
        if (parseFloat(packrow.availableQuantity, 10) === 0 && !isAllowedZero) return;
        packRowCount++;
        if (packRowCount > 1) {
          modifiedData.push({
            category: toStartCase(data.productData.category),
            ...data,
            ...packrow,
            hide: [
              'action',
              'category',
              'description',
              'image',
              'name',
              'sourcename',
              'status',
              'subname',
              'tags',
              'updatedAt',
            ],
            id: data.id,
            name: data.productData.name,
            subname: data.productData.subname,
          });
          return;
        }
        modifiedData.push({
          category: toStartCase(data.productData.category),
          ...data,
          ...packrow,
          id: data.id,
          name: data.productData.name,
          subname: data.productData.subname,
        });
      });
    }
    const groups = modifiedData.filter(item => includesSearchText(
      searchText, [
        item.category,
        item.name,
        item.sourcename,
        item.subname,
        `${item.count} ${item.uom} ${item.pack}`,
      ],
    ));
    return groups;
  };

  getGroupsForOrderedTable = () => {
    const { data } = this.props;
    const modifiedData = [];
    if (!data) return [];
    if (data) {
      modifiedData.push({
        category: toStartCase(data.productData.category),
        ...data,
        name: data.productData.name,
        subname: data.productData.subname,

      });
    }
    return modifiedData;
  };

  render() {
    const { fields, isOrderedTable, searchText } = this.props;
    let detailData = null;
    if (isOrderedTable) {
      detailData = this.getGroupsForOrderedTable();
    } else {
      detailData = this.getGroups();
    }

    return (
      <div className="block-box">
        {
          fields.map((field, index) => (
            <div className="block-container">
              {
                detailData.map((row, rowIndex) => {
                  const value = field.render ? field.render({ ...row, setState: this.updateStateData }) : (row.isSeparator ? '' : row[field.name]);
                  const searchedValue = !field.searchDisabled && !field.render && searchText
                    ? <HighlightText text={value} highlight={searchText} /> : value;
                  const className = typeof field.className === 'function' ? field.className(row) : field.className;
                  const isEmpty = row.hide && row.hide.indexOf(field.name) > -1;
                  const soldOut = Math.floor(parseFloat(row.availableQuantity)) <= 0;
                  
                  if (field.mobileHidden || isEmpty) return null;
                  return (
                    <div key={rowIndex} style={{opacity: soldOut ? 0.5 : 1}}>
                      <div className="value">
                        <div className={className}>{searchedValue}</div>
                      </div>
                    </div>
                  );
                })
              }
            </div>
          ))
        }
      </div>
    );
  }
}

export default OrderSheetBoxItem;
